/* © ИП Коробкин И.Н., KIN DIGITAL CRM+ */
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { Button, KV, PageHeader, Spinner } from '@/components/ui';
import { api } from '@/lib/api';
import { useAuth } from '@/lib/auth';

/** Ф-2: окно «О программе» - название, версия, правообладатель, регистрационные номера, перечень компонентов. */
export function AboutPage() {
  const { can } = useAuth();
  const { data } = useQuery({ queryKey: ['about'], queryFn: () => api.get('/about') });
  const [show, setShow] = useState(false);
  const comp = useQuery({ queryKey: ['about-comp'], queryFn: () => api.get('/about/components'), enabled: show });
  if (!data) return <Spinner />;
  return (
    <>
      <PageHeader title="О программе" />
      <div className="card mb-5 p-5">
        <div className="mb-3 flex items-center gap-3"><img src="/favicon.svg" alt="" className="h-10 w-10" />
          <div><div className="text-lg font-semibold">{data.name}</div><div className="text-sm text-slate-500">версия {data.version}</div></div></div>
        <KV items={[
          ['Правообладатель', data.holder],
          ['Авторское право', data.copyright],
          ['Свидетельство о регистрации программы для ЭВМ', data.fipsCertificate ?? 'регистрация в Роспатенте в процессе'],
          ['Запись в реестре российского ПО', data.registryRecord ?? 'заявление не подано'],
          ['Сайт', <a key="s" className="text-brand-700 underline" href={`https://${data.site}`} target="_blank" rel="noreferrer">{data.site}</a>],
          ['Сторонние компоненты', `${data.components} (открытые лицензии MIT, BSD, Apache-2.0 и совместимые)`],
        ]} />
        <p className="mt-3 text-xs text-slate-500">Программа работает на оборудовании лицензиата. Разработчик не имеет доступа к данным. Внешние сервисы (ИИ, SMS, сведения о контрагентах) подключаются только администратором лицензиата.</p>
      </div>
      {can('license.manage') && (
        <div className="card p-4">
          <Button variant="secondary" size="sm" onClick={() => setShow((v) => !v)}>{show ? 'Скрыть' : 'Показать'} перечень компонентов</Button>
          {show && (comp.data ? (
            <table className="mt-3 w-full text-sm"><thead className="bg-slate-50"><tr><th className="th">Компонент</th><th className="th">Версия</th><th className="th">Лицензия</th></tr></thead>
              <tbody>{comp.data.components.map((c: any) => <tr key={c.name + c.version} className="border-t border-slate-100"><td className="td">{c.name}</td><td className="td">{c.version}</td><td className="td">{c.license}</td></tr>)}</tbody></table>
          ) : <Spinner />)}
        </div>
      )}
    </>
  );
}
